import { Modal } from '@atoms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';

const SuccessModal: FC<{ onClose: () => void; open: boolean }> = ({ onClose, open }) => (
  <Modal title="" open={open} onClose={onClose}>
    <Box margin="auto" display="flex" alignItems="center" flexDirection="column" pb="12px">
      <CheckCircleIcon color="info" sx={{ fontSize: 83 }} />
      <Typography mt="16px" mb="48px" variant="body1" textAlign="center">
        New Enterprise account has been created successfully!
      </Typography>
      <Button color="info" variant="contained" onClick={onClose} fullWidth>
        Got it
      </Button>
    </Box>
  </Modal>
);

export default SuccessModal;
